import Ajax from '@/lib/ajax'

export default {
  /**
   * 获取相册列表
   * @param pageSize
   * @param currentPage
   */
  getAlbumsList(pageSize: number, currentPage: number) {
    return Ajax.get('/api/albumManagement/albums', {
      params: {
        MaxResultCount: pageSize,
        SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize
      }
    })
  },

  /**
   * 新增/修改相册
   * @param pageSize
   * @param currentPage
   */
  createAlbums(name: number, sort = 0, id?: number) {
    let ajaxType = id ? 'put' : 'post'
    let ajaxUrl = id
      ? `/api/albumManagement/albums/${id}`
      : '/api/albumManagement/albums'

    return Ajax[ajaxType](ajaxUrl, {
      name: name,
      sort: sort
    })
  },
  /**
   * 根据相册id查询图片列表
   * @param id
   * @param pageSize
   * @param currentPage
   */
  getImagesList(id: number, pageSize: number, currentPage: number, sorting?: string) {
    return Ajax.get('/api/albumManagement/images', {
      params: {
        id: id,
        MaxResultCount: pageSize,
        SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
        Sorting: sorting
      }
    })
  },

  /**
   * 给相册添加图片
   * @param albumId 相册Id
   * @param url
   */
  createImg(albumId: number, urls: string[], fileNames: string[]) {
    return Ajax.post('/api/albumManagement/images', {
      albumId: albumId,
      urls: urls,
      fileNames:fileNames
    })
  },

  /**
   * 更新图片名称
   * @param id
   * @param name
   */
  updateImgName(id: number, name: string) {
    return Ajax.put(`/api/albumManagement/images/name/${id}`, {
      name: name
    })
  },

  /**
   * 删除图片
   */
  deleteImg(id: number) {
    return Ajax.delete(`/api/albumManagement/images/${id}`)
  },
  /**
   * 批量删除图片
   */
  deleteImgs(ids: number[]) {
    let params = {
      ids: ids
    }
    return Ajax.delete(`/api/albumManagement/images`, {
      params: params
    })
  },
  /**
   * 转移相册
   */
  transferAlbum(id: number, ids: number[]) {
    return Ajax.put(`/api/albumManagement/images/album/${id}`, ids)
  }
}
